import React from "react";
import { useTranslation } from "react-i18next";
import Button from "../common/Button";
import useAnalyticsContext from "../../hooks/useAnalyticsContext.js";
import useScrollToHomeSection from "../../hooks/useScrollToHomeSection.js";
import {
  trackCTA,
  trackSectionViewed,
  useSectionOnceObserver,
} from "../../lib/analytics";
import { WRS_SECTION } from "./sections.js";
import useLocalizedHref from "../../hooks/useLocalizedHref.js";

/**
 * Closing statement.
 *
 * Two actions, in the order a visitor from search actually wants them: the
 * plan that contains the RSVP, and — for whoever is not ready to look at a
 * price — the invitation the RSVP lives inside, which is the one thing on the
 * page that answers "what is my guest actually going to open?".
 *
 * `trackLead` fires on neither. A scroll to the pricing section is a CTA click
 * and nothing more, and an internal navigation to a sibling page is not a lead
 * by any definition this site uses — `/try`, which IS counted as one, is
 * deliberately absent from this page (see RsvpHero).
 */
const RsvpFinalCta = () => {
  const { t } = useTranslation();
  const localize = useLocalizedHref();
  const analyticsContext = useAnalyticsContext();
  const scrollToPlans = useScrollToHomeSection("pricing");

  const sectionRef = useSectionOnceObserver(() =>
    trackSectionViewed(WRS_SECTION.FINAL_CTA, analyticsContext),
  );

  return (
    <section ref={sectionRef} className="section wps-section wps-final">
      <div className="container">
        <div className="wps-final-inner">
          <h2 className="heading-136">{t("weddingRsvp.finalCta.heading")}</h2>
          <p className="body-20 wps-final-body">
            {t("weddingRsvp.finalCta.body")}
          </p>
          <Button
            href={localize("/#pricing")}
            text={t("weddingRsvp.finalCta.ctaPrimary")}
            className="button-lg"
            onClick={(e) => {
              trackCTA("wedding_rsvp_final_cta", {
                ...analyticsContext,
                ctaName: "see_plans",
              });
              scrollToPlans(e);
            }}
          />
          <p className="dwi-final-secondary">
            <a
              className="wps-text-link"
              href={localize("/digital-wedding-invitation")}
              onClick={() =>
                trackCTA("wedding_rsvp_final_cta", {
                  ...analyticsContext,
                  ctaName: "digital_wedding_invitation",
                })
              }
            >
              {t("weddingRsvp.finalCta.ctaSecondary")}
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default RsvpFinalCta;
